module.exports = __webpack_public_path__ + "img/help6_dashboard_secondrow.7421131e.png";